import { render, staticRenderFns } from "./UserViewBankCards.vue?vue&type=template&id=b621e0ae&scoped=true&"
import script from "./UserViewBankCards.vue?vue&type=script&lang=js&"
export * from "./UserViewBankCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b621e0ae",
  null
  
)

export default component.exports